import React from 'react';
import NavbarAdminHome from '../components/NavbarAdminHome';
import MenuCard from '../components/MenuCard';
import {NavLink} from 'react-router-dom';
import FooterAdmin from '../components/FooterAdmin';

function AdminHomePage() {
  return (
    <div>
      <NavbarAdminHome />
      <div className='w-full h-navbar-mobile sm:h-navbar'></div>
      <div className='flex justify-center w-full h-auto bg-white min-h-[82vh] items-end py-10'>
        <div className='flex flex-wrap gap-10 px-10 md:px-20 justify-center w-full max-w-[1800px]'>
          
          <NavLink to="/ResultsAdmin">
            <MenuCard text="EXÁMENES" image="/images/ResultsIcon.svg" />
          </NavLink>

          <NavLink to="/NewsAdmin">
            <MenuCard text="NOTICIAS" image="/images/NewsIcon.svg" />
          </NavLink>

          {/*<NavLink to="/AppointmentAdmin">
            <MenuCard text="CITAS" image="/images/AppointmentsIcon.svg" />
          </NavLink>*/}

          <NavLink to="/TestsAdmin">
            <MenuCard text="PRUEBAS" image="/images/TestsIcon.svg" />
          </NavLink>

          <NavLink to="/CategoriesAdmin">
            <MenuCard text="CATEGORÍAS" image="/images/CategoriesIcon.svg" />
          </NavLink>

          <NavLink to="/PackagesAdmin">
            <MenuCard text="PAQUETES" image="/images/PackagesIcon.svg" />
          </NavLink>

          <NavLink to="/CampaignsAdmin">
            <MenuCard text="CAMPAÑAS" image="/images/CampaignsIcon.svg" />
          </NavLink>
          
          <NavLink to="/InquiriesAdmin">
            <MenuCard text="CONSULTAS" image="/images/InquiriesIcon.svg" />
          </NavLink>
        </div>
      </div>

      <FooterAdmin />
    </div>
  )
}

export default AdminHomePage
